// extracted by mini-css-extract-plugin
export default {"BooksDesc":"BooksDesc_BooksDesc__niQui"};